// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Проєкти» (Projects, ключ `prj`, група `management`). */
export const projectsManifest: IModuleManifest = {
  key: 'prj',
  group: 'management',
  slug: 'projects',
  prefix: 'PRJ',
  name: { en: 'Projects', uk: 'Проєкти' },
  entities: [
    { key: 'prj', slug: 'prj', name: { en: 'Projects', uk: 'Проєкти' }, main: true },
    { key: 'project_milestone', slug: 'project-milestone', name: { en: 'Project Milestones', uk: 'Віхи' }, main: false },
  ],
  loadState: () => import('./state/projectsSlice').then((m) => m.projectsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
